import styled from 'styled-components';
import { Form } from 'react-bootstrap';


const FormLabel = styled(Form.Label)`
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: black;
    font-weight: 700;
`

export default FormLabel;